require('./customer.less');

class CustomerController {
    customer;

    commentIcon = {
        name:'comment',
        nonEmptyId:'comment',
        tooltip:'',
        functionCall:(event,line)=> this.showComment(event, line)
    };

    pickStatusIcon = {
        name:(row) => {
            return row.picklistCount === 0 ? '' : row.lineCount === row.picklistCount ? 'playlist_add_check' : 'playlist_add';
        },
        tooltip: (row) => {
            return row.picklistCount === 0 ? '' : row.lineCount === row.picklistCount ? 'Alle varelinjer tildelt plukkliste' : 'Varelinjer delvis tildelt plukkliste';
        }
    };

    structureLevelPickedIcon = {
        name: (row) => row.structureError ? 'flag' : '',
        tooltip: (row) => row.structureError ? 'Strukturvare del-plukket' : '',
        color: '#F44336'
    };

    tableDefinition = {
        settings: {title: "", hideFilter: true, editFunction: (event, customer)=> this.rowClicked(event, customer), promise: null, backFunction: () => this.backFunctionClicked()},
        columns:[
            {title:'', icon: this.structureLevelPickedIcon},
            {title:'Kundenummer', name:'customerNo'},
            {title:'Kundenavn', name: 'deliveryCustomerName'},
            {title:'Adresse', name: 'deliveryAddress1'},
            {title:'', icon: this.pickStatusIcon},
            {title:'', icon: this.commentIcon},
            {title:'# ordre', name: 'orderCount', type: 'number'},
            {title:'# varelinjer', name: 'lineCount', type: 'number'},
            {title:'# storage type', name: 'storageTypeCount', type: 'number'},
            {title:'# varelinjer plukket', name: 'pickedCount', type: 'number'},
            {title:'% ferdig', name: 'percentDone', type: 'percent'}
        ]
    };

    constructor(private $state, private $stateParams, private $location, private PickStatus, private toastService, private $filter, private $mdDialog){
        this.tableDefinition.settings.title = "Oversikt over kunder på lastebærer " + $stateParams.carName + " den " + $filter("date")($stateParams.date, "dd.MM.yyyy");
    }

    $onInit(){
        if(this.$stateParams.carId){
            //this tries to run before carId is set in URL. Therefore checking.
            this.PickStatus.getPickStatusShipments({date: this.$stateParams.date, bookingId: this.$stateParams.carId}).$promise.then((shipments) => {
                this.customer = shipments.map(x => {
                    x.percentDone = (x.pickedCount / x.lineCount) * 100;
                    return x;
                });
            }, (error) => {
                this.toastService.parseError(error);
            })
        }
    }

    showComment(event, line) {
        this.$mdDialog.show(
            this.$mdDialog.alert()
                .parent(angular.element(document.querySelector('#popupContainer')))
                .clickOutsideToClose(true)
                .title('Anmerkning')
                .textContent(line.comment)
                .ariaLabel('commentDialog')
                .ok('Lukk')
                .targetEvent(event)
        );
    }

    rowClicked (event, customer){
        this.$state.go("loggedin.expedition_distribution_article_lines", {
            date: this.$stateParams.date,
            carId: this.$stateParams.carId,
            carName: this.$stateParams.carName,
            customerId: customer.customerNo,
            customerName: customer.deliveryCustomerName,
            shipmentId: customer.id})
    }

    backFunctionClicked(){
        window.history.back();
    }
}

class CustomerOptions implements ng.IComponentOptions {
    controllerAs =  'c';
    public controller:string = "rkcCustomerController";
    public template: any = require('./customer.html');

}

rkcApp.controller("rkcCustomerController", ['$state', '$stateParams', '$location', 'PickStatus', 'toastService', '$filter', '$mdDialog', function($state, $stateParams, $location, PickStatus, toastService, $filter, $mdDialog){
    return new CustomerController($state, $stateParams, $location, PickStatus, toastService, $filter, $mdDialog);
}])
    .component("rkcCustomer", new CustomerOptions());


/** WEBPACK FOOTER **
 ** ./src/app/components/main/views/distribution/customer/customer.ts
 **/